import React from "react";
import "./MenuItemText.scss";

const MenuItemText = (props: {children?: React.ReactNode}) => {
  return <div className="call-control-menu-item-text">{props.children}</div>;
};

export default MenuItemText;
